export default __webpack_public_path__ + "static/step-schedule-c31e3f23b9e189c2f40caea65d55d30b.svg";